export const EventTopics = [
  { _id: 'careerServices', name: 'Career Services' },
  { _id: 'employmentServices', name: 'Employment Services' },
  { _id: 'informationServices', name: 'Information Services' },
  { _id: 'skillDevelopment', name: 'Skill Development' },
  { _id: 'financialSupport', name: 'Support-Financial' },
  { _id: 'nonFinancialSupport', name: 'Support Non-Financial' },
];
